/**
 * upbitPosition.js — 업비트(fiat) 포지션의 필드 시맨틱을 한 곳에 모은다.
 *
 * ⚠️ 업비트 응답의 `balance`는 KRW가 아니라 **코인 수량**이다
 * (2026-08-23 실계좌 실측: BTC `balance`=0.28482302, `current_amount`=30,278,965가 평가액).
 * 이 착각으로 DAS-172의 "보내야 할 금액" 차감이 0.28원만 빠지는 버그가 났다.
 * dashboard_page(총계)와 btcDca(적립 지표)가 같은 해석을 쓰도록 여기로 모았다 (DAS-175).
 */

/** 포지션 1건의 KRW 평가액. `current_amount`가 정본, 없으면 수량×현재가, 그것도 없으면 수량×평단. */
export const fiatPositionValueKRW = (p) => {
    const currentAmount = parseFloat(p?.current_amount);
    if (Number.isFinite(currentAmount) && currentAmount > 0) return currentAmount;
    const qty = parseFloat(p?.balance) || 0;
    const price = parseFloat(p?.current_price) || parseFloat(p?.avg_buy_price) || 0;
    return qty * price;
};

/** 포지션 1건의 보유 수량(코인 단위). */
export const fiatPositionQty = (p) => parseFloat(p?.balance) || 0;

/** 포지션 1건의 매수 원금(KRW) = 수량 × 평단. 평단이 없으면 0. */
export const fiatPositionPrincipalKRW = (p) => {
    const qty = fiatPositionQty(p);
    const avg = parseFloat(p?.avg_buy_price) || 0;
    return qty * avg;
};
